import Toaster from "@/components/toaster";
import Protected from "@/pages/protected";
import { InvoiceCorrectionError } from "@/pages/tools/invoice_correction/error";
import { DataService } from "@/services/data";
import { InvoiceCorrectionType } from "@/types/tools/invoice_correction";
import { Outlet, RouteObject, defer, redirect } from "react-router-dom";

const InvoiceCorrectionRoute: RouteObject = {
    path: "correction-facture",
    element: (
        <Protected groups={["app_tools_admin", "team_finance"]}>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            index: true,
            async lazy() {
                let { InvoiceCorrectionSearchPage } = await import("@/pages/tools/invoice_correction/search");
                return { Component: InvoiceCorrectionSearchPage };
            },
        },
        {
            path: ":invoice_number",
            async lazy() {
                let { InvoiceCorrectionCommitPage } = await import("@/pages/tools/invoice_correction/commit");
                return { Component: InvoiceCorrectionCommitPage };
            },
            errorElement: <InvoiceCorrectionError />,
            loader: async ({ params }) => {
                const invoice_number = decodeURIComponent(params.invoice_number || "");
                const invoice = await DataService.client.url(`/tools/invoice_correction/search/`).post({ invoice_number: invoice_number }).json();
                return defer({ invoice });
            },
            action: async ({ request }) => {
                const data = await request.json();
                try {
                    const invoice_correction = (await DataService.client.url(`/tools/invoice_correction/`).post(data).json()) as InvoiceCorrectionType;
                    return redirect(`/outils/correction-facture/success/${invoice_correction.id}`);
                } catch (e) {
                    console.error(e);
                    Toaster.error(`Une erreur est survenue`);
                    return {};
                }
            },
            children: [
                {
                    path: "annuler",
                    action: async ({ request }) => {
                        const data = await request.json();
                        try {
                            const invoice_correction = (await DataService.client.url(`/tools/invoice_correction/cancel/`).post(data).json()) as InvoiceCorrectionType;
                            return redirect(`/outils/correction-facture/success/${invoice_correction.id}`);
                        } catch (e) {
                            console.error(e);
                            Toaster.error(`Une erreur est survenue`);
                            return {};
                        }
                    }
                }
            ]
        },
        {
            path: "success/:invoice_correction_id",
            async lazy() {
                let { InvoiceCorrectionSuccessPage } = await import("@/pages/tools/invoice_correction/success");
                return { Component: InvoiceCorrectionSuccessPage };
            },
            loader: async ({ params }) => {
                const invoice_correction_id = decodeURIComponent(params.invoice_correction_id || "");
                const invoice_correction = await DataService.client.url(`/tools/invoice_correction/${invoice_correction_id}/`).get().json();
                return defer({ invoice_correction });
            }
        }
    ]
};
export default InvoiceCorrectionRoute;
